import type { ReactNode } from 'react'

type Props = {
  children: ReactNode
  color: 'green' | 'red' | 'gray' | 'yellow'
  className?: string
}

const colorMap = {
  green: 'bg-success-50 text-success-700',
  red: 'bg-error-50 text-error-700',
  gray: 'bg-gray-100 text-gray-700',
  yellow: 'bg-yellow-50 text-yellow-700',
}

export default function ShopifyTableTag({
  children,
  color,
  className = '',
}: Props): JSX.Element {
  return (
    <p
      className={`px-2 py-0.5 w-fit rounded-lg text-sm ${
        className ? className + ' ' : ''
      } ${colorMap[color]}`}
    >
      {children}
    </p>
  )
}
